import { checkDateIsZeroValue } from "lib/checkDateIsZeroValue";
import {
  BrandColorPalette,
  ColorPalette,
  StatusColorPalette,
} from "lib/styles/colors";
import ComplianceError from "lib/svgs/ComplianceError";
import ComplianceSuccess from "lib/svgs/ComplianceSuccess";
import ComplianceWarning from "lib/svgs/ComplianceWarning";

export function getExpirationInfo(
  expDate?: Date | string | null,
  iconOnlyIfGood?: boolean
): {
    icon: React.ReactNode | null;
    formattedText: string;
    color: ColorPalette;
  } {
  if (!expDate || (expDate && checkDateIsZeroValue(expDate))) {
    return {
      color: BrandColorPalette.BRANDING,
      formattedText: "",
      icon: null,
    };
  }

  const expAt: Date = new Date(expDate);
  const now = new Date();
  let formattedText = "";

  const diff = now.getTime() - expAt.getTime();
  if (diff > 0) {
    // Expired
    return {
      color: StatusColorPalette.DANGER_TEXT,
      formattedText: "Expired Credentials",
      icon: <ComplianceError />,
    };
  } else {
    const numDays = Math.floor(Math.abs(diff) / (1000 * 3600 * 24));
    // Warning
    if (numDays <= 120) {
      return {
        color: StatusColorPalette.WARNING_DECORATION,
        formattedText: `Expires in: ${numDays} Days`,
        icon: <ComplianceWarning />,
      };
    }
    // Compliant -- show how long
    if (numDays > 365) {
      const numYears = Math.floor(numDays / 365);
      if (numYears === 1) {
        formattedText = `Expires in: ${numYears} Year`;
      } else {
        formattedText = `Expires in: ${numYears} Years`;
      }
    } else {
      formattedText = `Expires in: ${numDays} Days`;
    }
    return {
      color: StatusColorPalette.SUCCESS_TEXT,
      formattedText: iconOnlyIfGood ? "" : formattedText,
      icon: <ComplianceSuccess />,
    };
  }
}
